import type { PointOfInterest } from '@api/types'
import { usePlaces } from '@features/places/usePlaces'
import { useI18n } from '@i18n/I18nProvider'
import { Photo } from '@ui/Photo'
import { Screen } from '@ui/Screen'
import { ErrorState, LoadingState } from '@ui/States'
import { Link } from 'wouter'

// Lugares con foto, en el orden en que llegan; los que no tienen no salen en la galería.
export const withPhotos = (places: readonly PointOfInterest[]): PointOfInterest[] =>
	places.filter((place) => place.photoUrls.length > 0)

// Galería (spec `route`: no es una entidad, son los lugares de interés con fotografía). Usa la
// lista de lugares del mapa (misma caché) y cada foto abre la ficha del lugar.
export const GalleryPage = () => {
	const { t } = useI18n()
	const { data, error, isPending, refetch } = usePlaces()

	if (isPending)
		return (
			<Screen>
				<LoadingState shape="grid" />
			</Screen>
		)
	if (error || !data) return <ErrorState error={error} onRetry={() => refetch()} />

	const places = withPhotos(data.items)
	return (
		<Screen title={t('gallery.title')} backHref="/mas">
			{places.length === 0 ? (
				<p className="py-8 text-center text-lg text-earth-800">{t('gallery.empty')}</p>
			) : (
				<ul className="grid grid-cols-2 gap-3">
					{places.map((place) => (
						<li key={place.id}>
							<Link
								href={`/lugares/${encodeURIComponent(place.id)}`}
								className="block overflow-hidden rounded-3xl bg-white shadow-sm active:bg-earth-100"
							>
								<Photo src={place.photoUrls[0]} alt="" className="aspect-square w-full object-cover" />
								<span className="block p-3 leading-snug font-bold text-forest-800">{place.name}</span>
							</Link>
						</li>
					))}
				</ul>
			)}
		</Screen>
	)
}
